import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import GalleryCategoryForm from "./GalleryCategoryForm";

export default function EditGalleryCategory() {
  const navigate = useNavigate();
  const { gallerycategory_id } = useParams();
  const [data, setData] = useState({ name: "", status: "0" });
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    ApiRequest("GET", `${ApiEndpoints.galleryCategory.edit}${gallerycategory_id}`)
      .then((response) => setData(response.gallery_category))
      .catch((error) => toast.error(error.response?.data?.message || "Unable to load category."));
  }, [gallerycategory_id]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.name.trim()) return toast.error("Category name is required.");
    setSaving(true);
    try {
      const response = await ApiRequest("POST",
        `${ApiEndpoints.galleryCategory.update}${gallerycategory_id}`, data);
      toast.success(response.message); navigate("/gallery-categories");
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to update category.");
    } finally { setSaving(false); }
  };
  return <><AdminHeader pagename={{ name: "Gallery Management", user: "Admin", innerpage: "Gallery Categories / Edit" }} />
    <div className="add-content-page"><GalleryCategoryForm formId="categoryEdit" data={data}
      setData={setData} onSubmit={handleSubmit} saving={saving} />
      <button form="categoryEdit" className="default-btn" disabled={saving}>Save <span></span></button>
    </div></>;
}
